'use strict';

var _parse = require('parse');

var _parse2 = _interopRequireDefault(_parse);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

require('regenerator-runtime/runtime');

var _Actions = require('./Actions');

var _Actions2 = _interopRequireDefault(_Actions);

var _AppRoutes = require('./AppRoutes');

var _AppRoutes2 = _interopRequireDefault(_AppRoutes);

var _client = require('react-dom/client');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

require('babel-polyfill');
require('../sass/app.scss');
require('../lib/jquery.payment.js');

// Initialize the Parse here
_parse2.default.initialize(PARSE_APP_ID, PARSE_CLIENT_ID);
_parse2.default.serverURL = PARSE_SERVER_URL;
_Actions2.default.loadFbLoginApi();

var container = document.getElementById('root');
var root = (0, _client.createRoot)(container);
root.render(_react2.default.createElement(_AppRoutes2.default, null));


//////////////////
// WEBPACK FOOTER
// ./src/App.jsx
// module id = 0
// module chunks = 0